// 导入 Vue 创建应用的函数
import { createApp } from 'vue';
// 导入主应用组件
import App from './App.vue';
// 导入路由配置
import router from './router';
// 导入状态管理
import store from './store';
// 导入 Element Plus 图标库
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
// 导入全局引用文件
import "./server/global";
// 导入防止按钮重复点击的指令
import directives from '@/utils/plugins'

// 创建 Vue 应用实例
const app = createApp(App)
// 注册 Element Plus 图标组件
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
// 使用状态管理、路由，并挂载应用到 DOM
app.use(store).use(router).mount('#app');
